/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ clicks: NonNullable<unknown>, impressions: NonNullable<unknown>, conversions: NonNullable<unknown> }} Sklik_Stats_LineInputs */

const cs_sklik_stats_line = /** @type {(inputs: Sklik_Stats_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Za posledních 30 dní: ${i?.clicks} kliků · ${i?.impressions} zobrazení · ${i?.conversions} konverzí`)
};

const en_sklik_stats_line = /** @type {(inputs: Sklik_Stats_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last 30 days: ${i?.clicks} clicks · ${i?.impressions} impressions · ${i?.conversions} conversions`)
};

/**
* | output |
* | --- |
* | "Last 30 days: {clicks} clicks · {impressions} impressions · {conversions} conversions" |
*
* @param {Sklik_Stats_LineInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_stats_line = /** @type {((inputs: Sklik_Stats_LineInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_Stats_LineInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_stats_line(inputs)
	return cs_sklik_stats_line(inputs)
});